export default __webpack_public_path__ + "static/Sash-3-0d22db56d03cff3dd2450510a89c2869.png";